import { DeepPartial, Messages } from '@empathybroker/ebx-gluon';

export const pt: DeepPartial<Messages> = {
  resultsFoundHTML: '<span class="ebx-results-number__count">{resultsNumber}</span> resultados',
  nextQueriesSuggestions: {
    title: 'Quien buscó {query} también buscó...'
  },
  search: {
    inputPlaceholderAlternativesHTML: ['O que procura?']
  },
  facets: {
    clearFilters: 'Limpar filtros',

    toggle: {
      groups: {
        'all-facets': {
          outside: {
            openHTML: 'Mostrar ({selectedFiltersCount}) filtros',
            closeHTML: 'Ocultar filtros'
          }
        }

      }

    }
  },
  nextQueries: {
    titleHTML: ''
  },
  history: {
    disable: 'off',
    enable: 'on'
  },
  results: {
    addToCart: 'Adicionar ao carrinho'
  }
};
